import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  analyticsEnabled,
  clearAnalyticsFarmContext,
  clearAnalyticsUser,
  trackPageExit,
  trackScreenView,
  setAnalyticsFarmContext,
  setAnalyticsUserFromEmail,
} from 'analytics/ga4';
import { cookies, storageKeys } from 'static';

type StoredAuth = {
  username?: string;
};

const getStoredUsername = (): string | undefined => {
  const storedAuthRaw = localStorage.getItem(cookies.FarmersPlanToken);

  if (!storedAuthRaw) {
    return undefined;
  }

  try {
    const storedAuth = JSON.parse(storedAuthRaw) as StoredAuth;
    return typeof storedAuth.username === 'string' ? storedAuth.username : undefined;
  } catch {
    return undefined;
  }
};

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!analyticsEnabled) {
      return;
    }

    const screenName = `${location.pathname}${location.search}${location.hash}`;
    const enteredPageTimestamp = Date.now();
    const storedUsername = getStoredUsername();

    if (!storedUsername) {
      clearAnalyticsFarmContext();
      clearAnalyticsUser();
    } else {
      const storedFarmId = sessionStorage.getItem(storageKeys.RecentFarmId);
      const storedFarmName = sessionStorage.getItem(storageKeys.RecentFarmName);
      const storedFarmOrgNumber = sessionStorage.getItem(storageKeys.RecentFarmOrgNumber);
      setAnalyticsFarmContext(storedFarmId, storedFarmName, storedFarmOrgNumber);
      void setAnalyticsUserFromEmail(storedUsername);
    }

    trackScreenView(screenName);

    return () => {
      trackPageExit(screenName, (Date.now() - enteredPageTimestamp) / 1000);
    };
  }, [location.hash, location.pathname, location.search]);

  return null;
}
